import React from 'react';
import ModuleTable from 'Components/Core/ModuleTable';
import FormElement from 'Components/Core/Form/FormElement';
import BooleanIcon from 'Components/Core/BooleanIcon';
import './Rezepte.css';

export default function RezeptKategorien(props) {

    const x = props.x;
    const wafId = props.id;
    const dialogFormId = "form-" + props.id;

    const formFields =
        <React.Fragment>
            <FormElement type="text"
                x={x}
                dialogId={dialogFormId}
                wafId={wafId}
                id="name"
                mandatory={true}
                title="Kategorie"
                fieldValue=""
                maxLength="50"
            />
            <FormElement type="checkbox" x={x} wafId={wafId} id="disabled" title="Inaktiv" />
        </React.Fragment>


    return (
        <ModuleTable
            id={props.id}
            tableId="kategorieid"
            dialogFormId={dialogFormId}
            x={x}
            classes={`module-rezept-kategorien`}
            tableClasses={`rezept-kategorien-list`}
            filterableColumns={['name']}
            title={props.title}
            addDeleteRow={x.was.memberLevel < 3}
            addTitle="Neue Kategorie anlegen"
            module="Rezepte"
            listTask="KategorieList"
            deleteTask="KategorieDelete"
            onAddHeader={(addHeader) => {
                addHeader('Kategorie');
                addHeader('Deaktiviert');
            }}
            onAddColumn={(key, value) => {
                switch (key) {
                    case 'name':
                        return value;
                    case 'disabled':
                        return <BooleanIcon value={value} />;
                    default:
                        return false;
                }
            }}
            onEditRow={(e, rowFields, rowId) => {
                x.waf.setAddSend(wafId, 'id', rowId);
                x.waf.set(wafId, 'name', rowFields.name);
                x.waf.set(wafId, 'disabled', rowFields.disabled);
                x.waf.hide(wafId, 'message');
                x.wad[dialogFormId].setTitle("Kategorie bearbeiten");
                x.wad[dialogFormId].show(() => { x.waf.focus(wafId, 'name') });
            }}
            formFields={formFields}
            formSendTask="KategorieSave"
            sendButtonLevel={3}
        />
    )

};
